import { NotificationConfigResponse } from '@docbay/schemas';
import { UpdateNotificationsSettingsProps } from 'common/types/notificationsSettings';
import axiosInstance from 'integration/api/axiosInstance';

export const NotificationsSettingsAPI = {
  /**
   * Fetches the notifications settings for a given clinic owner.
   *
   * @param id - The unique identifier of the clinic owner whose notifications settings will be fetched.
   * @returns A Promise that resolves to the fetched notification configuration response.
   */
  fetchNotificationsSettings: (id: string) =>
    axiosInstance.get<NotificationConfigResponse>(
      `/notifications-config/clinic-owner/${id}`,
    ),

  /**
   * Updates the notifications settings for a given clinic owner.
   *
   * @param params - An object containing the unique identifier of the clinic owner and the updated notification configuration data.
   * @returns A Promise that resolves to the updated notification configuration response.
   */
  updateNotificationsSettings: (params: UpdateNotificationsSettingsProps) =>
    axiosInstance.patch<NotificationConfigResponse>(
      `/notifications-config/clinic-owner/${params.id}`,
      params.data,
    ),
};
